import React, {useState, useEffect} from 'react';
import { Redirect } from 'react-router-dom';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { validationClienteData } from '../../../../../utils/validations';
import CircularProgress from '@material-ui/core/CircularProgress';
import FullScreenLoader from '../../../../../components/FullScreenLoader';
import DataClient from '../../../../../components/Forms/SignUpClient/DataClient'
import { addFormValuesClient } from '../../../../../store/modules/formValuesClient';
import { assertionStepClientSubmittedAction, stepsClientSubmittedResetAction } from '../../../../../store/modules/assertionStepsClientSubmitted';
import Typography from '@material-ui/core/Typography';
import * as ROUTES from '../../../../../routes';
import {signUpClient} from '../../../../../store/actions/UserAction'

const SignUpData = (props) => {

  const [initialValues, setInitialValues] = useState({ email:'', password:'',termsAndConditions: false})
  const [wasSignUpSuccessfully, setWasSignUpSuccessfully ]= useState(false)
  const [loading, setLoading]= useState(false)
  const [loadingFormData, setLoadingFormData]= useState(false)
  const [redirect, setRedirect]= useState(false)
  const [error, setError]= useState(null)
  const [user, setUser]= useState({})

  const {
    isSecondStepClientSubmitted,
    isThirdStepClientSubmitted,
    signUpClient,
    // formValuesClient,
    // stepsClientSubmitted,
  } = props;


  const { authError } = props;

   useEffect(() => {
   
    if (isSecondStepClientSubmitted) {
      if (isThirdStepClientSubmitted) {
        setLoadingFormData(false);
      } else {
        setLoadingFormData(false);
      }
    } else {
      setRedirect(true)
    }
  },[]); 

/*   const createNewUser = (email, password , cliente ) => {
    return new Promise((resolve, reject) => {
      const { createUser } = props.firebase;
      createUser({ email, password }, cliente)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  };
 */


    const onSubmit = async (values,  { setSubmitting, setFieldError , setErrors}) => {

        try{
            setSubmitting(false);
            setLoading(true) 
            const { submitFormValuesClient,submitStepClient, stepsClientSubmitted } = props;
            
             const  profile ={...values, ...props.formValuesClient}
              const { email, password} = profile;
                signUpClient(email, password, profile)
                .then(snap => {
                  setUser(snap)
                  setWasSignUpSuccessfully(true)
                  handleResetFormValues()
                })
                .catch(error=> {
                  setLoading(false) 
                  switch (error.code) {
                    case 'auth/user-not-found':
                      return setFieldError('email', 'Esta cuenta no existe' );
                    case 'auth/wrong-password':
                      return setFieldError( 'password', 'Esta contraseña es incorrecta' );
                    case 'auth/too-many-requests':
                      return setFieldError(
                        'password', 'Limite de intentos porfavor espere un momento');
                    case 'auth/email-already-in-use':
                        return setFieldError(
                          'email',
                          'La dirección de correo electrónico ya existe'
                      );
                    default:
                      return setFieldError({ email: 'Ocurrió un error' });
                  }
                }) 
             /*  await createNewUser( email, password,  values );
              const user = firebase.auth().currentUser; */

             /*  await user.sendEmailVerification();
              setWasSignUpSuccessfully(true) */
            } catch (error) {
                const { authError } = props;
                if (authError && authError.code === 'auth/email-already-in-use') {
                    setLoading(false)
                    setFieldError(
                        'email',
                        'La dirección de correo electrónico ya existe'
                    
                    );
                } else {
                    setLoading(false)
                    setError(error)
                }
            }
        }

    const handleResetFormValues = () => {
        const { submitFormValuesClient, stepsSubmittedReset, history } = props;
        let formValuesClient = {
        name: '',
        lastName:'',
        email: '',
        password: '',
        phone: '',
        termsAndConditions: false
        };
        submitFormValuesClient(formValuesClient).then(() => {
        stepsSubmittedReset();
        history.push(ROUTES.LAWYERS_CONTACTED );
        });
    };

   const handleClose = () => {
        setLoading(false)
      };


      if (loadingFormData) {
        return (
          <div className="flexContainer--center">
            <CircularProgress color="secondary" />
          </div>
        );
      }
  
      if (redirect) {
        return <Redirect to="/usuario-registro" />;
      }

      return ( 
        <>
         <FullScreenLoader loading={loading} />
         {error && authError && (
          <Typography align="center" color="error">
            {authError.message}
          </Typography>
        )}
          <Formik
          initialValues={initialValues}
          validationSchema={validationClienteData}
          onSubmit={onSubmit}
          render={props => <DataClient {...props} />}
          />

           {/*  {wasSignUpSuccessfully && (
            <EmailVerificationModal
                noticeText="SE ENVIÓ UN CORREO PARA VERIFICAR TU CUENTA"
                email={user && user.email && user.email}
                handleClick={handleResetFormValues}
          />
          )} */}
        </>
      );
    }


    const mapDispatchToProps = dispatch => ({
       submitFormValuesClient: formValues => dispatch(addFormValuesClient(formValues)),
       submitStepClient: steps => dispatch(assertionStepClientSubmittedAction(steps)),
        stepsSubmittedReset: () => dispatch(stepsClientSubmittedResetAction), 
        signUpClient: (email, password,profile ) => dispatch(signUpClient(email, password, profile))
      });
      
      const mapStateToProps = ({
        formValuesClient,
        stepsClientSubmitted,
      /*   firebase: { auth, authError, profile } */
      }) => ({
       /*  auth,
        authError,
        profile, */
        formValuesClient,
        isSecondStepClientSubmitted: stepsClientSubmitted.personalInformation,
        isThirdStepClientSubmitted: stepsClientSubmitted.signUp
      });


    const enhance = connect(
        mapStateToProps,
        mapDispatchToProps
      );
      
export default enhance(SignUpData);